const DEFAULT_TIMELY_APP_URL = "https://timely365.com";

function getTimelyAppUrl(): URL {
  const localTimelyUrl =
    typeof window !== "undefined" &&
    new Set(["localhost", "127.0.0.1", "::1"]).has(window.location.hostname)
      ? `${window.location.protocol}//${window.location.hostname}:3001`
      : DEFAULT_TIMELY_APP_URL;
  const configured = String(
    process.env.REACT_APP_TIMELY365_APP_URL || localTimelyUrl
  ).trim();

  try {
    return new URL(configured);
  } catch {
    return new URL(DEFAULT_TIMELY_APP_URL);
  }
}

function addCareIntegrationContext(url: URL, businessUrl?: string): URL {
  url.searchParams.set("source", "plany-care");
  if (businessUrl) url.searchParams.set("businessUrl", businessUrl);
  return url;
}

export function buildTimelyManagementUrl(businessUrl?: string): string {
  const url = new URL("/biz/calendar", getTimelyAppUrl());
  url.searchParams.set("v", "booking");
  return addCareIntegrationContext(url, String(businessUrl || "").trim()).toString();
}

export function buildTimelyPathUrl(pathname: string, search = "", hash = ""): string {
  const url = getTimelyAppUrl();
  url.pathname = `/${String(pathname || "").replace(/^\/+/, "")}`;
  url.search = search;
  url.hash = hash;
  return url.toString();
}

export function buildTimelyPublicBookingUrl(
  businessUrl?: string
): string | null {
  const normalizedBusinessUrl = String(businessUrl || "").trim();
  if (!normalizedBusinessUrl) return null;

  const url = new URL(
    `/b/${encodeURIComponent(normalizedBusinessUrl)}/booking`,
    getTimelyAppUrl()
  );
  return addCareIntegrationContext(url).toString();
}
